module.exports = __webpack_public_path__ + "static/media/management_icon.be0c1fe1.png";